import { render, staticRenderFns } from "./NeuerKunde.vue?vue&type=template&id=6863cfd6&"
import script from "./NeuerKunde.vue?vue&type=script&lang=js&"
export * from "./NeuerKunde.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports